import { useListUsersForAccountQuery } from "@generated";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useEffect, useState } from "react";
import { User } from "../types";
import { generated } from "@generated";
import { AppDispatch } from "@store/*";

const useGetAllUsers = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const dispatch = useDispatch<AppDispatch>();
  const { data, isLoading, error } = useListUsersForAccountQuery({
    slug: accountSlug,
    page: {},
  });
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(isLoading);

  useEffect(() => {
    if (!isLoading && data && data.data && data.meta && !error) {
      setUsers(
        data.data.map((user) => ({
          id: user.id?.toString() || "",
          name: user.attributes?.name || "",
        }))
      );
      const pageCount = data.meta["page-count"] || 1;

      if (pageCount > 1) {
        setLoading(true);
        const fetchPages = async () => {
          try {
            for (let page = 2; page <= pageCount; page++) {
              // Trigger additional fetches for each page
              const resultAction = await dispatch(
                generated.endpoints.listUsersForAccount.initiate({
                  slug: accountSlug,
                  page: {
                    number: page,
                  },
                })
              ).unwrap(); // Assuming this is where the 'unwrap()' method is now chained

              // Check if resultAction.data exists and is an array before mapping
              if (resultAction.data && Array.isArray(resultAction.data)) {
                setUsers((prevUsers) => [
                  ...prevUsers,
                  ...resultAction.data!.map((user) => ({
                    id: user.id?.toString() || "",
                    name: user.attributes?.name || "",
                  })),
                ]);
              }
            }
          } catch (err) {
            console.error("Failed to fetch additional pages:", err);
          } finally {
            setLoading(false);
          }
        };

        fetchPages();
      }
    }
  }, [data, isLoading, error, accountSlug, dispatch]);

  return { users, loading, error };
};

export default useGetAllUsers;
